import React, { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { BsChevronRight  } from "react-icons/bs"; // Bootstrap Icons (>)
import {alertActions, authActions} from '../../../store/actions'
import Alert from '../../../module/alert/'

let inputRef;
const LoginPassReset = props => {
    
    const pinArr = ["", "", "", "", "", ""];
    const [pinNum, setPinNum] = useState("");
    // const [pinNumFocus, setPinNumFocus] = useState(true);

    const inputRefConfirm = useRef();
    const pinArrConfirm = ["", "", "", "", "", ""];
    const [pinNumConfirm, setPinNumConfirm] = useState("");
    // const [pinNumConfirmFocus, setPinNumConfirmFocus] = useState(false);

    useEffect(() => { 
        if (pinNum.length === 6 && pinNumConfirm.length === 6) {
            inputRef.disabled = true;
            inputRefConfirm.current.disabled = true;

            if (pinNum !== pinNumConfirm) {
                alert("비밀번호가 일치하지 않습니다.");
                setPinNumConfirm("");
                inputRefConfirm.current.value="";
                inputRef.disabled = false;
                inputRefConfirm.current.disabled = false;
            }else{                
                 /**
                 *  간편로그인 재설정
                 */
                props.pinNumReset(
                    pinNum,
                    props.deviceId
                );
            }
        };
    }, [inputRefConfirm ,pinNum, pinNumConfirm]);

    return(
    <React.Fragment>
        <div className="content">
            <div className="inner">

                <div className="login section-loginpass">
                    <div className={"login-wrap"}>
                        <div className="login-title">
                            <h5>간편비밀번호 설정</h5>
                            <span className="info">사용하실 <strong>간편비밀번호 6자리</strong>를 입력해주세요.</span>
                        </div>

                        <div className="login-body">
                            <div className="login-content">
                                <form name="form" >
                                    <fieldset>
                                        <div className="pin-area">
                                            <div style={{ position: 'relative', paddingBottom: 10 }} onClick={() => inputRef.focus()}>
                                                <h5 className="pin-area--title">비밀번호 입력</h5>
                                                <input
                                                    type="number" // 숫자 패드만 나오게
                                                    pattern="\d*" // iphone 숫자 패드만 나오게
                                                    // android는 width가 1이상이여야 value값이 정상적으로 들어옴
                                                    style={{ position: 'absolute', width: 1, opacity:0  }}
                                                    ref={
                                                        function (ref) {
                                                            if (ref !== null && !inputRef) {
                                                                inputRef = ref;
                                                                ref.focus();
                                                            }
                                                        }
                                                    }
                                                    // onFocus={() => setPinNumFocus(true)}
                                                    // onBlur={() => setPinNumFocus(false)}
                                                    onChange={({ target }) => {
                                                        const value = target.value.substr(0, 6);
                                                        setPinNum(value);

                                                        if (target.value.length > 6) {
                                                            target.value = value;
                                                        }
                                                        if (target.value.length === 6) {
                                                            inputRefConfirm.current.focus();
                                                        }
                                                    }}
                                                />
                                                <div style={{ position: 'absolute',  top: 0, left: 0, right: 0, bottom: 0 }} />
                                                {
                                                    pinArr.map((x, idx) => (
                                                            <span
                                                                key={idx}
                                                                //  className={`word ${pinNum.length >= idx + 1 ? 'active' : ''} ${pinNumFocus && ((pinNum.length + 1) === idx + 1 || (pinNum.length === 0 && idx === 0) || (pinNum.length === 6 && idx === 5)) ? 'blink' : ''}`} />
                                                                className={`word${pinNum && pinNum.length >= idx + 1 ? ' active' : ''}`}/>
                                                        )
                                                    )
                                                }
                                            </div>

                                            <div
                                                style={{ position: 'relative' }}
                                                onClick={() => inputRefConfirm.current.focus()}
                                            >
                                                <h5 style={{ paddingTop: 10 }} className="pin-area--title">비밀번호 재입력</h5>
                                                <input
                                                    type="number" // 숫자 패드만 나오게
                                                    pattern="\d*" // iphone 숫자 패드만 나오게
                                                    // android는 width가 1이상이여야 value값이 정상적으로 들어옴
                                                    style={{ position: 'absolute', width: 1, opacity: 0 }}
                                                    ref={inputRefConfirm}
                                                    // onFocus={() => setPinNumConfirmFocus(true)}
                                                    // onBlur={() => setPinNumConfirmFocus(false)}
                                                    onChange={({ target }) => {
                                                        const value = target.value.substr(0, 6);
                                                        setPinNumConfirm(value);

                                                        if (target.value.length > 6) {
                                                            target.value = value;
                                                        }
                                                    }}
                                                />
                                                <div style={{ position: 'absolute',  top: 0, left: 0, right: 0, bottom: 0 }} />

                                                {
                                                    pinArrConfirm.map((x, idx) => (
                                                            <span
                                                                key={idx}
                                                                // className={`word ${pinNumConfirm.length >= idx + 1 ? 'active' : ''} ${pinNumConfirmFocus && ((pinNumConfirm.length + 1) === idx + 1 || (pinNumConfirm.length === 0 && idx === 0)) ? 'blink' : ''}`} />
                                                                className={`word${pinNumConfirm && pinNumConfirm.length >= idx + 1 ? ' active' : ''}`}/>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </fieldset>                                       
                                </form>                                   

                                <div className="login-location-info text-center">
                                    <a href="/login" >로그인하기 <BsChevronRight /></a>
                                </div>
                            </div>

                        </div>
                        {/* login-body */}							
                    </div>
                </div>

            </div>
        </div>
        <Alert/>
    </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        deviceId: state.userInfo?.deviceId
    }
}
const actionCreators = {
    pinNumReset: authActions.pinNumReset,
    error: alertActions.error
}

export default connect(
    mapStateToProps,
    actionCreators
)(LoginPassReset)